import { render, staticRenderFns } from "./NsMessageAction.vue?vue&type=template&id=078909b2&scoped=true&"
import script from "./NsMessageAction.vue?vue&type=script&lang=js&"
export * from "./NsMessageAction.vue?vue&type=script&lang=js&"
import style0 from "./NsMessageAction.vue?vue&type=style&index=0&id=078909b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078909b2",
  null
  
)

export default component.exports